export default __webpack_public_path__ + "static/media/cyberarchW.4ef3d308.png";